/* unplugin-vue-components disabled */import { render } from "./Tile.vue?vue&type=template&id=4d1f26f5&scoped=true&ts=true"
import script from "./Tile.vue?vue&type=script&lang=ts"
export * from "./Tile.vue?vue&type=script&lang=ts"

import "./Tile.vue?vue&type=style&index=0&id=4d1f26f5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1f26f5"]])

export default __exports__